import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  FiUsers,
  FiUser,
  FiMail,
  FiPhone,
  FiCalendar,
  FiChevronRight,
  FiHome,
} from "react-icons/fi";

import { getMyReferralLevels } from "../../store/slices/profile";

const LevelTwo = () => {
  const dispatch = useDispatch();

  const {
    myReferralLevels = {},
    myReferralLevelsLoading,
    error,
  } = useSelector((state) => state.profile);


  useEffect(() => {
    dispatch(getMyReferralLevels());
  }, [dispatch]);


  const levelTwoData = myReferralLevels?.level2 || {};

  const levelTwoUsers = Array.isArray(levelTwoData?.users)
    ? levelTwoData.users
    : [];

  const levelTwoCount = levelTwoData?.count ?? levelTwoUsers.length;


  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return date;
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="gi-referral-page">


      <div className="gi-breadcrumb">
        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>My Network</span>
        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Level 2</span>
      </div>

      <section className="gi-referral-table-card">

        <div className="gi-referral-table-header">
          <div>
            <h2>Level 2 Referrals</h2>

            <p>Members referred through your Level 1 network</p>
          </div>

          <div className="gi-referral-count">
            <FiUsers />

            <span>{levelTwoCount} Members</span>
          </div>
        </div>

        <div className="gi-referral-table-wrapper">
          <table className="gi-referral-table">
            <thead>
              <tr>
                <th className="text-center">#</th>

                <th className="text-center">
                  Name
                </th>

                <th className="text-center">User ID</th>

                <th className="text-center">
                  Email
                </th>

                <th className="text-center">
                  Mobile Number
                </th>

                <th className="text-center">
                  Joined Date
                </th>
              </tr>
            </thead>

            <tbody>

              {myReferralLevelsLoading && (
                <tr>
                  <td
                    colSpan="7"
                    className="gi-table-message"
                  >
                    Loading Level 2 referrals...
                  </td>
                </tr>
              )}


              {!myReferralLevelsLoading && error && (
                <tr>
                  <td
                    colSpan="7"
                    className="gi-table-message"
                  >
                    {error}
                  </td>
                </tr>
              )}

              {!myReferralLevelsLoading &&
                !error &&
                levelTwoUsers.length === 0 && (
                  <tr>
                    <td
                      colSpan="7"
                      className="gi-table-message"
                    >
                      No Level 2 referrals found
                    </td>
                  </tr>
                )}

              {!myReferralLevelsLoading &&
                !error &&
                levelTwoUsers.map((item, index) => {
                  const status =
                    item.joiningStatus ||
                    item.status ||
                    "PENDING";

                  return (
                    <tr
                      key={
                        item._id || item.userId || index
                      }
                    >

                      <td className="gi-referral-number text-center">
                        {String(index + 1).padStart(
                          2,
                          "0",
                        )}
                      </td>

                      <td>
                        <div className="text-center">

                          <strong>
                            {item.name || "-"}
                          </strong>


                        </div>
                      </td>

                      <td className="text-center">
                        <span className="gi-user-id">
                          {item.userId || "-"}
                        </span>
                      </td>

                      <td className="text-center">
                        <span className="gi-email-text">
                          {item.email || "-"}
                        </span>
                      </td>

                      <td className="text-center">
                        <span className="gi-mobile-text">
                          {item.mobileNo || "-"}
                        </span>
                      </td>


                      <td className="text-center">
                        <span className="gi-date-text">
                          {formatDate(item.createdAt)}
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default LevelTwo;
